const PROCESS_INTERVAL = 250;
const ONE_SECOND = 1000;
const SCALE_FACTOR = 360 / 720;

export { PROCESS_INTERVAL, ONE_SECOND, SCALE_FACTOR };
